import classnames from 'classnames'
import React, { useMemo } from 'react'
import { getIn } from 'formik'
import { useSelector } from 'react-redux'

import { useSubAllocationRemainingBudget } from '../../../../../../hooks/remainingBudgetHooks'
import { useLineItemForecastData } from './useLineItemForecastData'
import { formatNumber, formatCurrency } from '../../../../../../../../../../../helpers/numbers'

import ErrorMessage from '../../../../../../../../../../../components/Form/ErrorMessage'
import { ReactComponent as CloseIcon } from '../../../../../../../../../../../assets/icons/close-grey.svg'
import Field from '../../../../../../../../../../../components/Form/Field'

import { rightSelector } from '../../../../../../../../../../../modules/selectors/rights'
import { selectedPartnershipSelector } from '../../../../../../../../../../../modules/selectors/partnerships'

import { getIsBudgetAllocationType } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'

import { GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { RIGHT_INVENTORY_SELECT, UNITS } from '../../../../../../fields'

import useSelectedItemsTableStyles from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/InventoryAccessAndAllocationSection/SubAllocationTables/styles'
import useStyles from '../styles'

const SubAllocationMultiFieldItem = ({ formik, name, index, value, label, deleteHandler, className }) => {
  const selectedItemsTableClasses = useSelectedItemsTableStyles()
  const classes = useStyles()

  const right = useSelector(rightSelector)
  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = useSelector(selectedPartnershipSelector)
  const currencySymbol = gamAccount?.currency_symbol || ''

  const inventoryBudgets = useSubAllocationRemainingBudget()
  const isBudgetAllocationType = getIsBudgetAllocationType(right)
  const remainingBudget = inventoryBudgets[value]?.remaining

  const { values, errors, touched } = formik

  const itemPath = `${name}[${index}].${UNITS}`
  const units = getIn(values, itemPath)
  const itemError = getIn(errors, itemPath)
  const itemTouched = getIn(touched, itemPath)

  const inventoryItem = getIn(values, `${RIGHT_INVENTORY_SELECT}[${index}]`)

  const billingEvent = right?.billing_event
  const microAmount = inventoryItem?.prices?.[billingEvent]

  const forecastBudgetDisplay = useMemo(() => {
    // formatted remaining budget conditionally with currency symbol
    return isBudgetAllocationType
      ? formatCurrency(remainingBudget, { max: 2 }, { symbol: currencySymbol })
      : formatNumber(remainingBudget, { max: 2 })
  }, [isBudgetAllocationType, currencySymbol, remainingBudget])

  const { forecastErrorMessage } = useLineItemForecastData({
    values,
    inventory: [inventoryItem],
    microAmount,
    units
  })

  return (
    <div className={selectedItemsTableClasses.container}>
      <div className={classnames(selectedItemsTableClasses.row, className)}>
        <div className={classnames(selectedItemsTableClasses.label)}>{label}</div>

        <span className={classnames(classes.remainingBudget, classes.textCenter)}>{forecastBudgetDisplay}</span>

        <Field
          formik={formik}
          name={itemPath}
          type="number"
          className={classnames(selectedItemsTableClasses.inlineField, {
            [classes.hasError]: itemError && itemTouched
          })}
          symbol={isBudgetAllocationType ? currencySymbol : undefined}
        />
        <CloseIcon onClick={() => deleteHandler(value)} className={selectedItemsTableClasses.selectedValueRemove} />
      </div>
      {forecastErrorMessage && <ErrorMessage error={forecastErrorMessage} />}
    </div>
  )
}

export default SubAllocationMultiFieldItem
